import { HttpInterceptorFn } from '@angular/common/http';
import { DEFAULT_HTTP_OPTIONS } from './api.config';
import { finalize } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const headers = req.headers; // Add more to headers if needed

  const cloned = req.clone({
    headers,
    withCredentials: DEFAULT_HTTP_OPTIONS.withCredentials,
  });

  //  this.loaderService.showLoader(); // TODO later
  return next(req).pipe(
    finalize(() => {
      // this.loaderService.hideLoader() // TODO later
    })
  );
};
